/**
 * Sequences view — F5→multi-step follow-up.
 */

import { useState, useEffect } from "react";
import { getClients, applyMembrane } from "../lib/api-clients";

export function SequencesView({ isOperator }: { isOperator: boolean }) {
  const [sequences, setSequences] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const clients = getClients();
    if (!clients) { setLoading(false); return; }
    clients.envoy.listSequences()
      .then((res: any) => setSequences(applyMembrane(res?.sequences || res || [], isOperator)))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [isOperator]);

  if (loading) return <div className="loading">Loading sequences…</div>;

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">Outreach</span>
        <h1>Sequences</h1>
      </div>
      {error && <div className="error-state">{error}</div>}
      {sequences.length === 0 ? (
        <div className="empty-state">No sequences yet. Create a multi-step follow-up sequence from a campaign.</div>
      ) : (
        <div className="card-grid">
          {sequences.map((s: any, i: number) => (
            <div key={i} className="card">
              <div className="card-title">{s.name}</div>
              <div className="card-meta">
                <span className="badge" data-status={s.status || "pending"}>{s.status || "draft"}</span>
                <span>{s.step_count ?? 0} steps</span>
                <span>{s.enrolled_count ?? 0} enrolled</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
